export enum FILTER_TYPE_PATH_KEY {
    theme = 'theme',
    type = 'type',
    author = 'author',
}
